import { ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTES, UI_AUTHENTICATED_ROUTES } from "../../constants/routes";
import s from "./header.module.scss";
import { CSSProperties } from "styled-components";
import { InputField } from "../../components/InputField";
import inputStyles from "../../components/InputField/input.module.scss";
import SearchIcon from "../../assets/icons/search-icon.png";
import { TooltipThumbnail } from "../../components/Thumbnail";

import {
  useMemoizedAuthenticatedSelector,
  useTerminateCurrentSessionAndLogOut,
} from "../../hooks/index";
import { convertTokenStringToObject } from "../../utils/index";
import { BrandIcon } from "../../assets/svgs/BrandLogo";
import { ReportsIcon } from "../../assets/svgs/ReportsIcon";
import { TransIcon } from "../../assets/svgs/TransIcon";

type HeaderProps = Readonly<{
  isLoggedIn: boolean;
  menuItems: ReactElement;
  indexRoute?: string;
  headerStyle?: CSSProperties;
}>;

export function Header(props: HeaderProps) {
  const { menuItems, headerStyle } = props;
  const { pathname } = useLocation();
  return (
    <header
      className={[[s.heading], "page-header"].join(" ")}
      style={headerStyle}
    >
      <div className={s["heading-brand-and-search"]}>
        {/* <ImageRenderer
          src={brandLogo}
          href={"/"}
          alt="API Marketplace"
          data-test="brand"
        /> */}
        <BrandIcon />
        {pathname === PUBLIC_ROUTES.MARKETPLACE_APIS ||
          (pathname === PUBLIC_ROUTES.MARKETPLACE && (
            <InputField
              disabled
              placeholder="Search APIs"
              containerStyle={{
                width: "322px",
                height: "40px",
                marginRight: "4rem",
              }}
              iconRight={
                <img
                  src={SearchIcon}
                  height={20}
                  width={20}
                  className={inputStyles["icon-right"]}
                  alt="search_icon"
                />
              }
            />
          ))}
      </div>
      <div className={s.menuItems}>{menuItems}</div>
    </header>
  );
}
function RenderLoggedInThumbnail() {
  const { token } = useMemoizedAuthenticatedSelector();
  const tokenObject = convertTokenStringToObject(token);
  const logout = useTerminateCurrentSessionAndLogOut();
  const navigate = useNavigate();

  const goTo = (url: string) => navigate(url);

  return (
    <TooltipThumbnail
      name={`${tokenObject?.lastName} ${tokenObject?.firstName}`}
      dropdown={
        <div className={s["dropdown"]}>
          <div className={s["dropdown-notification-nudge"]}>
            <span className="text-small text-neutral-900">
              Some notification.
            </span>
          </div>
          <div className={s["dropdown-identity"]}>
            <p className={s["dropdown-thumb"]}>{`${tokenObject?.lastName.charAt(
              0
            ) || ""} ${tokenObject?.firstName.charAt(0) || ""}`}</p>
            <p
              className={[
                s["dropdown-name"],
                ["header-7 text-neutral-900"],
              ].join(" ")}
            >
              {/* {`${tokenObject?.lastName} ${tokenObject?.firstName}`} */}
            </p>
            <small className="text-small text-neutral-700">
              {tokenObject?.email}
            </small>
          </div>
          <div className={s["items"]}>
            <button
              className="text-medium text-neutral-900"
              onClick={() => goTo(UI_AUTHENTICATED_ROUTES.WALLET_TRANSACTIONS)}
            >
              <TransIcon  className="h-[1em]"/>
              Transactions
            </button>
            <button
              className="text-medium text-neutral-900"
              onClick={() => goTo(UI_AUTHENTICATED_ROUTES.REPORTS)}
            >
               <ReportsIcon  className="h-[1em]"/>
              Reports
            </button>

            <button className="text-medium text-neutral-900" onClick={logout}>
              {/* <img src={LogoutIcon} alt="logout" /> */}
              Log out
            </button>
          </div>
        </div>
      }
    />
  );
}

// Dashboard header
export function DashboardMenuItems() {
  return (
    <>
      {/* <Link to={ROUTES.DOCUMENTATION} target="_blank" text="Docs" />
      <Button outlined href={UI_AUTHENTICATED_ROUTES.PROJECTS} color="neutral" text="Projects" /> */}
      <RenderLoggedInThumbnail />
    </>
  );
}
